import * as XLSX from 'xlsx';

function resolveField(row, field) {
    const value = field.split('.').reduce((obj, key) => (obj || {})[key], row);
    if (Array.isArray(value)) return value.join(', ');
    return value === undefined || value === null ? '' : value;
}

export function exportToExcel(filename, columns, data) {
    if (!data || data.length === 0) return false;

    const rows = data.map(row => columns.map(col => resolveField(row, col.field)));
    const worksheet = XLSX.utils.aoa_to_sheet([columns.map(col => col.title), ...rows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, filename.endsWith('.xlsx') ? filename : filename + '.xlsx');
    return true;
}
